import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from '@mui/material'

import colors from '@settings/styleSettings'
import OpenLoanTable from '@components/table/openLoanTable'
import ClosedLoanTable from '@components/table/closedLoanTable'

const SelectLoan = () => {
  const [selectedTab, setSelectedTab] = useState('Ativos')

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  return (
    <div>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        variant="fullWidth"
        sx={{
          '& .MuiTabs-flexContainer': {
            justifyContent: 'space-between',
            margin: '0 200px',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: colors.primary,
            color: colors.primary,
          },
          '& .MuiTab-root': {
            fontSize: '16px',
            fontWeight: '600',
            textTransform: 'none',
            lineHeight: '22px',
          },
        }}
      >
        <Tab
          label="Ativos"
          value="Ativos"
          sx={{
            '&.Mui-selected': {
              color: colors.primary,
            },
          }}
        />
        <Tab
          label="Devolvidos"
          value="Devolvidos"
          sx={{
            '&.Mui-selected': {
              color: colors.primary,
            },
          }}
        />
      </Tabs>
      {
        selectedTab === 'Ativos' ? (
          <div>
            <OpenLoanTable />
          </div>
        ) : (
          <div>
            <ClosedLoanTable />
          </div>
        )

      }
    </div>
  )
}

SelectLoan.propTypes = {
  beneficiary: PropTypes.shape({ name: PropTypes.string, id: PropTypes.number }).isRequired,
}

export default SelectLoan
